export const GOOGLE_INFO = 'googleInfo';

export const CONCEDO_CODE_VERIFIER = 'concedoCodeVerifier';

export const CONCEDO_STATE = 'concedoState';

export const CONCEDO_CLIENT_ID = 'concedoClientID';

export const CONCEDO_INFO = 'concedoInfo';

export const CONCEDO_REDIRECT_URI = 'concedoRedirectURI';

export const REDIRECT_USER_REQUEST_URI = 'redirectUserRequestURI';
